import { keyframes, styled } from "goober";
import { ClickButton } from "./ClickButton";
import { Text } from "./Text";

const Element = styled(ClickButton)`
  padding: 12px 20px;
  border-radius: 12px;
  color: var(--text-primary);
  background: var(--surface-primary);
  outline: 0.5px solid var(--border-alpha);
  position: relative;

  &:hover:not(:disabled) {
    background: var(--surface-hover);
  }

  &:active:not(:disabled) {
    opacity: 0.8;
  }

  .inner {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    line-height: 16px;
    gap: 8px;
  }

  &[data-muted="true"] .inner {
    opacity: 0.5;
  }

  &[data-muted="true"]:hover .inner {
    opacity: 1;
  }

  img {
    width: 16px;
    height: 16px;
    border-radius: 4px;
  }
`;

const bounce = keyframes`
  0%, 80%, 100% { transform: translateY(0); }
  40% { transform: translateY(-4px); }
`;

const LoadingDots = styled("span")`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 2px;
  width: 16px;
  height: 16px;

  span {
    width: 2px;
    height: 2px;
    border-radius: 50%;
    background-color: currentColor;
    animation: ${bounce} 1s ease-in-out infinite;
  }

  span:nth-child(1) {
    animation-delay: 0s;
  }
  span:nth-child(2) {
    animation-delay: 0.15s;
  }
  span:nth-child(3) {
    animation-delay: 0.3s;
  }
`;

interface Props extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  isLoading?: boolean;
  logo: string;
  text: string;
  muted?: boolean;
}

export function IntegrationButton({
  isLoading,
  logo,
  text,
  muted,
  ...props
}: Props) {
  return (
    <Element
      {...props}
      data-muted={muted ? "true" : undefined}
      disabled={props.disabled || isLoading}
    >
      <div className="inner">
        {isLoading ? (
          <LoadingDots>
            <span />
            <span />
            <span />
          </LoadingDots>
        ) : (
          <img src={logo} alt="Logo"></img>
        )}
        <Text variant="text-regular-md">{text}</Text>
      </div>
    </Element>
  );
}
